import { useEffect } from 'react'
import { useStateContext } from '../../context/StateContextAPI'
import { FacebookIcon, InstagramIcon, MainBackgroundVector } from '../../assets'
import PeterImage from '../../assets/peter.png'
import AlexImage from '../../assets/alex.png'
import useGoogleTag from '../../utils/gtag'
import { useTranslation } from 'react-i18next'
import './about-us.page.css'

const AboutUsPage = () => {
    const gtag = process.env.REACT_APP_GOOGLE_TAG || ""
    useGoogleTag(gtag)

    const { setActivePage } = useStateContext()
    const { t } = useTranslation()

    useEffect(() => {
        setActivePage(() => "about")
        window.scrollTo(0, 0)
    }, [setActivePage])

    const founders = [
        {
            name: t('about.peter'),
            surname: t('about.moog'),
            role: t('about.founderCeo'),
            knownFrom: t('about.knownFromPeter'),
            image: PeterImage,
            socials: [
                { icon: FacebookIcon, label: 'Facebook', url: 'https://www.facebook.com/petermoogofficial/' },
            ]
        },
        {
            name: t('about.alex'),
            surname: t('about.landenburg'),
            role: t('about.founderCoo'),
            knownFrom: t('about.knownFromAlex'),
            image: AlexImage,
            socials: [
                { icon: FacebookIcon, label: 'Facebook', url: 'https://www.facebook.com/AlexLandenburgOfficial/' },
                { icon: InstagramIcon, label: 'Instagram', url: 'https://www.instagram.com/alexlandenburg/' },
            ]
        }
    ]

    return (
        <div className="about-us-page">
            <img src={MainBackgroundVector} alt="" className="about-hero-bg" />

            {/* Hero + Founders Section */}
            <div className="about-hero-section">

                <div className="about-hero-content">
                    <div className="about-hero-title">
                        <span className="head-txt-off-white">{t('about.heroTitle1')}</span>
                        <span className="head-txt-primary">{t('about.heroTitle2')}</span>
                    </div>
                    <p className="about-hero-subtitle">
                        {t('about.heroSubtitle')}
                    </p>
                </div>

                <div className="about-founders-section">
                    {founders.map((founder, index) => (
                        <div className="about-founder-card" key={index}>
                            <div className="about-founder-image-wrapper">
                                <img src={founder.image} alt={`${founder.name} ${founder.surname}`} />
                                <div className="about-founder-image-overlay" />
                            </div>
                            <div className="about-founder-details">
                                <div className="about-founder-name">
                                    {founder.name}<br />{founder.surname}
                                </div>
                                <div className="about-founder-role">{founder.role}</div>
                                <div className="about-founder-known">
                                    <span className="about-known-label">{t('about.knownFromLabel')}</span>
                                    <span className="about-known-value">{founder.knownFrom}</span>
                                </div>
                                <div className="about-founder-socials">
                                    {founder.socials.map((social, i) => (
                                        <a
                                            key={i}
                                            href={social.url}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="about-social-icon"
                                            aria-label={social.label}
                                        >
                                            <img src={social.icon} alt={social.label} />
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Story Section */}
            <div className="about-story-section">
                <div className="about-story-header">
                    <span className="head-txt-off-white">{t('about.storyTitle1')}</span>
                    <span className="head-txt-primary">{t('about.storyTitle2')}</span>
                </div>
                <div className="about-story-content">
                    <div className="about-story-card">
                        <div className="about-story-year">{t('about.beginningTitle')}</div>
                        <div className="about-story-divider" />
                        <p className="about-story-text">
                            {t('about.beginningText')}
                        </p>
                    </div>
                    <div className="about-story-card">
                        <div className="about-story-year">{t('about.todayTitle')}</div>
                        <div className="about-story-divider" />
                        <p className="about-story-text">
                            {t('about.todayText')}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutUsPage
